import { IconMagicSolid, Space } from '@procurify/ui'

import {
  ConversationProgressStubStyled,
  ConversationThinkingSparkleStyled,
} from './styles/ConversationStreamStyled'

const SPARKLE_SIZE = 16

interface IConversationThinkingIndicatorProps {
  label?: Nullable<string>
  isAfterResponse?: boolean
}

// Internal pipeline codes (e.g. "record_intent_confirmation") arrive on the
// same field as human-readable progress copy; only copy with whitespace is
// meant for users.
const isHumanReadableLabel = (label: Nullable<string>): label is string =>
  label !== null && /\s/.test(label.trim())

export const ConversationThinkingIndicator = ({
  label = null,
  isAfterResponse = false,
}: IConversationThinkingIndicatorProps) => {
  if (!isHumanReadableLabel(label)) return null

  return (
    <ConversationProgressStubStyled
      role='status'
      $isAfterResponse={isAfterResponse}
    >
      <Space direction='horizontal' align='center' size='small'>
        <ConversationThinkingSparkleStyled>
          <IconMagicSolid color='ai' size={SPARKLE_SIZE} block aria-hidden />
        </ConversationThinkingSparkleStyled>
        <span>{label}</span>
      </Space>
    </ConversationProgressStubStyled>
  )
}
